import React, { useState } from 'react';
import { Coffee } from "lucide-react";
import qr from '../Imagenes/Qroscategui.jpeg'
import '../components/App.css'

const CoffeeButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <div>
      {/* Botón para abrir la ventana emergente */}
     { /*<button onClick={openModal}>Invitame un Cafe</button>*/}
      {/*--------------------------------------------------------------- */}
      <button onClick={openModal} id='colorBoton'>
      <Coffee size={25} />
      Invitame un café
    </button>

      {/* Ventana emergente */}
      {isOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            {/* Imagen */}
            <img
              src={qr}
              alt="Imagen de ejemplo"
              style={styles.image}
            />

            {/* Botón para cerrar la ventana emergente */}
            <button onClick={closeModal} style={styles.cancelButton}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Estilos para la ventana emergente
const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '20px',
  },
  cancelButton: {
    padding: '10px 20px',
    backgroundColor: '#ff4444',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
   
  },
};

export default CoffeeButton;